import axios from 'axios';
import { MessageBox } from 'element-ui';
import store from '@/store';
import { getToken, getPhone, getUserId } from '@/utils/auth';
import qs from 'qs';

// create an axios instance
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  withCredentials: true,
  // send cookies when cross-domain requests
  timeout: 30000,
  // request timeout
  responseType: 'json'
});

// request interceptor
service.interceptors.request.use(function (config) {
  // console.log('config', config)
  // do something before request is sent
  config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  if (store.getters.token) {
    // let each request carry token
    // ['token'] is a custom headers key
    // please modify it according to the actual situation
    config.headers['token'] = getToken();
    config.headers['phone'] = getPhone();
    config.headers['user_id'] = getUserId();
    config.headers['source'] = 303;
    config.headers['client_id'] = 303;
  }
  if (config.method === 'post') {
    if (!config.data) {
      config.data = {
        client_id: 303,
        source: 303
      };
    }
    if (config.data && !config.data.client_id) {
      config.data.client_id = 303;
      config.data.source = 303;
    }

    //如果参数中带有token 或者phone 则替换
    if (config.data.token) {
      config.headers['token'] = config.data.token;
    }
    if (config.data.phone) {
      config.headers['phone'] = config.data.phone;
    }
    config.data = qs.stringify(config.data);
  }
  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  var res = response.data;
  if (!res) {
    // 请求不到数据
    MessageBox.alert('您的访问出现错误，请联系管理人员', '错误', {
      type: 'error'
    });
    return Promise.reject(new Error('Error'));
  }

  // if the custom code is not 0, it is judged as an error.
  if (res.code !== 0) {
    // Message({
    //   message: res.message || 'Error',
    //   type: 'error',
    //   duration: 5 * 1000
    // })

    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    if (res.code === 406) {
      // to re-login
      MessageBox.confirm('您的登录已失效, 你可以重新登录或者取消继续留在这个页面', '登录失效', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(function () {
        window.location.href = '/login';
      });
    } else if (res.code === 403) {
      MessageBox.alert(res.msg || '您无权访问请求的数据', '无权限', {
        type: 'error'
      });
      return res;
    } else {
      MessageBox.alert(res.msg || '您的访问出现错误，请联系管理人员', '错误', {
        type: 'error'
      });
    }
    return Promise.reject(new Error(res.message || 'Error'));
  } else {
    return res;
  }
}, function (error) {
  console.log('err', error); // for debug
  if (error.request) {
    if (error.request.timeout === 30000) {
      MessageBox.alert('网络异常，请稍后刷新重试', '错误', {
        type: 'error'
      });
      return Promise.reject(error);
    }
  }
  MessageBox.alert(error.message || '您的访问出现错误，请联系管理人员', '错误', {
    type: 'error'
  });
  return Promise.reject(error);
});
export default service;